<template>
    <div v-if="isLoaded">
        <hobbies-elements
            v-for="(element, index) in elements"
            :key="`${element.id}-${index}`"
            :elements="element.elements"
            :id="element.id"
            :name="element.name"
            :width="element.width"/>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import HobbiesElements from '../components/hobbies/hobbiesElements'

export default {
    name: 'hobbies',
    components: {
        HobbiesElements
    },
    mounted () {
        this.$nextTick(() => {
            this.load()
        })
    },
    computed: {
        ...mapGetters({
            associations: 'hobbiesModule/getAssociations',
            sports: 'hobbiesModule/getSports',
            travels: 'hobbiesModule/getTravels',
            readings: 'hobbiesModule/getReadings'
        }),
        elements () {
            return [
                {id: 'associations', name: 'Associations', elements: this.associations, width: 305},
                {id: 'readings', name: 'Lectures', elements: this.readings, width: 216},
                {id: 'sports', name: 'Sports', elements: this.sports, width: 216},
                {id: 'travels', name: 'Voyages', elements: this.travels, width: 216}
            ]
        }
    },
    methods: {
        ...mapActions({
            load: 'hobbiesModule/loadHobbies',
            isLoaded: 'hobbiesModule/isLoaded'
        })
    }
}
</script>

<style scoped lang="scss">
 div {
    width: calc(100% - 58px) !important;
    margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/hobbies.vue